import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
    _createVNode(_component_Divider, { m: "1.2rem -1.6rem 0" }),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_component_Divider, { m: "0 -1.6rem 0" }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "reset pointer",
        disabled: !$data.prev.length,
        onClick: _cache[0] || (_cache[0] = $event => ($options.onReset()))
      }, " Reset ", 8 /* PROPS */, _hoisted_4),
      _createElementVNode("div", {
        class: "apply pointer",
        disabled: !$options.can_apply,
        onClick: _cache[1] || (_cache[1] = $event => ($options.onApply()))
      }, " Apply ", 8 /* PROPS */, _hoisted_5)
    ])
  ]))
}